import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import ProfileTitle from "./ProfileTitle";
import FormProfile from "../../Components/Form/FormProfile";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const ProfileEditData = () => {
    const { t } = useTranslation();
    const pageTitle = t('profile.form_update_profile.page_title');
    document.title = pageTitle;

    const { currentStore } = useStoreContext();
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate('/perfil');
    }
    
    const handleCancel = () => {
        navigate('/perfil');
    }

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>

                <div className="flex flex-col gap-2 p-2">

                    <ProfileTitle>{ pageTitle }</ProfileTitle>

                    <div className="md:max-w-md">
                        <FormProfile onSuccess={handleSuccess} onCancel={handleCancel} />
                    </div>

                </div>

            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileEditData;